import { useMemo, useState } from 'react';
import { FILTER_TO_CATEGORY, TemplatesFilterChip } from '../../config';
import { WhatsappTemplate } from '../../../types/whatsappTemplates';
import { ViewMode } from '@/components/ViewToggle/ViewToggle';

export const useWhatsappTemplateListFilters = (templates: WhatsappTemplate[]) => {
  const [selectedFilter, setSelectedFilter] = useState<TemplatesFilterChip>('All');
  const [viewMode, setViewMode] = useState<ViewMode>('card');
  const [searchValue, setSearchValue] = useState('');

  const filteredItems = useMemo(() => {
    const searchNormalized = searchValue.trim().toLowerCase();

    return templates.filter((item) => {
      const matchesFilter = selectedFilter === 'All' ? true : item.category === FILTER_TO_CATEGORY[selectedFilter];
      const matchesSearch = searchNormalized.length === 0 ? true : item.name.toLowerCase().includes(searchNormalized);

      return matchesFilter && matchesSearch;
    });
  }, [searchValue, selectedFilter, templates]);

  const templateFilters = useMemo(() => {
    if (templates.length === 0) {
      return [];
    }

    const categories = new Set<TemplatesFilterChip>();
    templates.forEach((template) => {
      const category = Object.entries(FILTER_TO_CATEGORY).find(([, value]) => value === template.category)?.[0] as TemplatesFilterChip;
      if (category) {
        categories.add(category);
      }
    });

    return ['All', ...Array.from(categories)] as TemplatesFilterChip[];
  }, [templates]);

  const hasActiveFilters = searchValue.trim().length > 0 || selectedFilter !== 'All';

  return {
    selectedFilter,
    setSelectedFilter,
    viewMode,
    setViewMode,
    searchValue,
    setSearchValue,
    filteredItems,
    templateFilters,
    hasActiveFilters,
  };
};
